<template>
  <table class="min-w-full leading-normal mt-1 text-gray text-xs" style="border: solid 1px #dedede;">
    <thead>
    <tr class="bg-gray-pale">
      <td colspan="12" class="px-2 py-2">Nature of Business</td>
    </tr>
    <tr class="text-left">
      <th class="px-2 py-1">ISIC Code</th>
      <th class="px-2 py-1">Breakdown</th>
    </tr>
    </thead>
    <tbody>
    <tr style="border: solid 1px #dedede;">
      <td class="px-2 py-1">{{ isicCode }}</td>
      <td class="px-2 py-1">
        <ul class="text-blue list-none m-0 p-0">
          <li v-for="(section, idx) in breakdown" :key="idx">
            <span class="text-gray italic hover:font-bold" :style="'display: inline-block; margin-left: '+(idx * 15)+'px'">-> {{ section }}</span>
          </li>
        </ul>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import {api} from "../../../../../../../../app/services/api.service";

export default {
  name: 'NatureOfBusinessISICView',
  props: {
    data: {
      type: Object,
      default: null,
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      sections: [],
      divisions: [],
      groups: [],
      classes: [],
      selectedSection: '',
      selectedDivision: '',
      selectedGroup: '',
      selectedClass: '',
      isicCode: '',
    };
  },
  computed: {
    breakdown() {
      var items = [];
      if (this.selectedSection && this.sections.length) {
        var s = this.sections.find(function (x) { return x.id === this.selectedSection; }.bind(this));
        if (s) items.push(s.code + " - " + s.description);
      }
      if (this.selectedDivision && this.divisions.length) {
        var d = this.divisions.find(function (x) { return x.id === this.selectedDivision; }.bind(this));
        if (d) items.push(d.code + " - " + d.description);
      }
      if (this.selectedGroup && this.groups.length) {
        var g = this.groups.find(function (x) { return x.id === this.selectedGroup; }.bind(this));
        if (g) items.push(g.code + " - " + g.description);
      }
      if (this.selectedClass && this.classes.length) {
        var c = this.classes.find(function (x) { return x.id === this.selectedClass; }.bind(this));
        if (c) items.push(c.code + " - " + c.description);
      }
      return items;
    }
  },
  watch: {
    selectedSection: function (newVal) {
      if (newVal) {
        this.selectedDivision = '';
        this.selectedGroup = '';
        this.selectedClass = '';
        this.divisions = [];
        this.groups = [];
        this.classes = [];
        this.fetchDivisions(newVal);
      }
      this.updateIsicCode();
    },
    selectedDivision: function (newVal) {
      if (newVal) {
        this.selectedGroup = '';
        this.selectedClass = '';
        this.groups = [];
        this.classes = [];
        this.fetchGroups(newVal);
      }
      this.updateIsicCode();
    },
    selectedGroup: function (newVal) {
      if (newVal) {
        this.selectedClass = '';
        this.classes = [];
        this.fetchClasses(newVal);
      }
      this.updateIsicCode();
    },
    selectedClass: function () {
      this.updateIsicCode();
    },
    data: {
      handler(val) {
        if (val) {
          this.selectedSection = val.sectionId || '';
          this.selectedDivision = val.divisionId || '';
          this.selectedGroup = val.groupId || '';
          this.selectedClass = val.classId || '';
          this.isicCode = val.isicCode || '';
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchSections();
    if (this.data) {
      this.selectedSection = this.data.sectionId || '';
      this.selectedDivision = this.data.divisionId || '';
      this.selectedGroup = this.data.groupId || '';
      this.selectedClass = this.data.classId || '';
      this.isicCode = this.data.isicCode || '';
    }
  },
  methods: {
    fetchSections() {
      var self = this;
      if (!api()) {
        if (this.data && this.data.isicCode) this.isicCode = this.data.isicCode;
        return;
      }
      api().get('/reservation/isic/parents')
        .then(function (res) {
          var list = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
          self.sections = list;
          if (self.data && self.data.sectionId) {
            self.selectedSection = self.data.sectionId;
            self.fetchDivisions(self.data.sectionId);
          }
        })
        .catch(function () { self.sections = []; });
    },
    fetchDivisions(sectionId) {
      var self = this;
      api().get('/reservation/isic?parentId=' + encodeURIComponent(sectionId))
        .then(function (res) {
          var list = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
          self.divisions = list;
          if (self.data && self.data.divisionId) {
            self.selectedDivision = self.data.divisionId;
            self.fetchGroups(self.data.divisionId);
          }
        })
        .catch(function () { self.divisions = []; });
    },
    fetchGroups(divisionId) {
      var self = this;
      if (!api()) return;
      api().get('/reservation/isic?parentId=' + encodeURIComponent(divisionId))
        .then(function (res) {
          var list = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
          self.groups = list;
          if (self.data && self.data.groupId) {
            self.selectedGroup = self.data.groupId;
            self.fetchClasses(self.data.groupId);
          }
        })
        .catch(function () { self.groups = []; });
    },
    fetchClasses(groupId) {
      var self = this;
      if (!api()) return;
      api().get('/reservation/isic?parentId=' + encodeURIComponent(groupId))
        .then(function (res) {
          var list = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
          self.classes = list;
          if (self.data && self.data.classId) self.selectedClass = self.data.classId;
          self.updateIsicCode();
        })
        .catch(function () { self.classes = []; });
    },
    updateIsicCode() {
      var code = '';
      if (this.selectedSection && this.sections.length) {
        var s = this.sections.find(function (x) { return x.id === this.selectedSection; }.bind(this));
        if (s && s.code) code += s.code;
      }
      if (this.selectedDivision && this.divisions.length) {
        var d = this.divisions.find(function (x) { return x.id === this.selectedDivision; }.bind(this));
        if (d && d.code) code += d.code;
      }
      if (this.selectedGroup && this.groups.length) {
        var g = this.groups.find(function (x) { return x.id === this.selectedGroup; }.bind(this));
        if (g && g.code) code += g.code;
      }
      if (this.selectedClass && this.classes.length) {
        var c = this.classes.find(function (x) { return x.id === this.selectedClass; }.bind(this));
        if (c && c.code) code += c.code;
      }
      this.isicCode = code || (this.data && this.data.isicCode) || '';
    },
  },
};
</script>

<style scoped>
ul.list-none {
  list-style-type: none;
}
</style>
